import { colors } from '@styles';
import styled from 'styled-components';
import { flexMixin } from '@styles/mixins';

interface StyledSliderProps {
    value: number;
}

export const Container = styled.div`
    width: 100%;
    margin: 25px auto;
    padding: 20px;
    background-color: ${colors.white};
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
`;

export const ControlsContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-top: 20px;
    gap: 20px;
`;

export const BtnContainer = styled.div`
    ${flexMixin('row', 'center', 'center')};
    gap: 10px;
`;

export const ControlButton = styled.button`
    ${flexMixin('column', 'center', 'center')};
    color: white;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    font-size: 16px;
    background-color: ${colors.white};
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;

    & svg {
        width: 34px;
        height: 34px;
        color: ${colors.grey};
    }

    &:hover {
        background-color: ${colors.iconHover};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }

    &:focus {
        outline: 2px solid ${colors.primaryBg};
        outline-offset: 2px;
    }
`;

export const ControlGroup = styled.div`
    display: flex;
    align-items: center;
    margin-top: 15px;
    gap: 10px;
`;

export const ControlLabel = styled.label`
    color: ${colors.grey};
    font-size: 14px;
    font-weight: 500;
    min-width: 70px;
`;

export const StyledSlider = styled.input<StyledSliderProps>`
    flex: 1;
    -webkit-appearance: none;
    height: 6px;
    border-radius: 3px;
    background: ${props =>
        `linear-gradient(to right, #a7388e 0%, #a7388e ${props.value * 100}%, #d4d5d8 ${props.value * 100}%, #d4d5d8 100%)`};

    &::-webkit-slider-thumb {
        -webkit-appearance: none;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: ${colors.primaryBg};
        cursor: pointer;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    &::-moz-range-thumb {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background: ${colors.primaryBg};
        cursor: pointer;
        border: none;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    }

    &:focus {
        outline: none;
    }
`;

export const VolumeValue = styled.span`
    color: ${colors.grey};
    font-size: 14px;
    font-weight: 500;
    min-width: 40px;
`;

export const ProgressValue = styled.span`
    color: ${colors.grey};
    font-size: 14px;
    font-weight: 500;
    min-width: 40px;
`;
export const InfoContainer = styled.div`
    ${flexMixin('row', 'center', 'center')};
    gap: 15px;
    & svg {
        color: #07bc0c;
        width: 24px;
        height: 24px;
    }
    & span {
        color: ${colors.grey};
    }
`;
